import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ErrorResponse } from "App";
import { QUERY_KEYS } from "constants/queryKeys";
import { errorModal } from "modules/error/ErrorHandlingModals";

import { putRejectAnalysisService } from "../api";

export const useRejectAnalysisMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putRejectAnalysisService,
    mutationKey: [QUERY_KEYS.reject_analysis],
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: [QUERY_KEYS.imports_listing] });
    },
    onError: (error: ErrorResponse) => errorModal(error)
  });
};
